import React, { useState, useEffect, useRef } from "react";

import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-hcl";
import "prismjs/components/prism-json";
import "prismjs/components/prism-clike";

import Editor from "react-simple-code-editor";
import "prismjs/themes/prism.css";

const HclViewerTerraformConfiguration = ({ content = {}, handleUpdate }) => {

  const [data, setData] = useState("");
  const [ready, setReady] = useState(false);


  useEffect(() => {
    try {
      const parsedConfiguration = JSON.parse(content);
      const decodedBase64Configuration = atob(parsedConfiguration.static.terraform);
      setData(decodedBase64Configuration);
      if (!ready){
        setReady(true);
      }
    } catch (error) {
      console.error("Failed to parse base64 string");
    }
  }, [content]);

  function handleChange(decodedBase64Configuration) {
    setData(decodedBase64Configuration);
    handleUpdate(btoa(decodedBase64Configuration));
  }


  return (<div>
    <div className="container_editor_area">
      <Editor
          value={data}
          onValueChange={code => handleChange(code)}
          highlight={code =>
              highlight(code, languages.hcl)
          }
          padding={10}
          className="container__editor"
      />
    </div>
  </div>);
};

export default HclViewerTerraformConfiguration;
